export const SET_OFFERINGS = 'eg-set-offerings';